import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { REQUEST_DIVISION_CANDIDATE_CLIENT, REQUEST_DIVISION_CANDIDATE_PRO, } from '../../../../define/consts/registration';
import { propShape } from '../../../../helpers/custom-prop-types';
import InputError from '../../Common/InputError';
import PlainInput from '../../Common/PlainInput';
const SlideSearchRegistrationRequestDivisionRadio = (props) => {
    const { input, meta } = props;
    const { value } = input;
    const divisions = [
        REQUEST_DIVISION_CANDIDATE_PRO,
        REQUEST_DIVISION_CANDIDATE_CLIENT,
    ];
    return (_jsxs("div", Object.assign({ className: 'field' }, { children: [_jsx("div", Object.assign({ className: 'row_title' }, { children: "\u6240\u5C5E\u7D44\u7E54" })), _jsx("div", Object.assign({ className: 'col_group' }, { children: divisions.map(({ name, value: setValue }) => (_jsx("div", Object.assign({ className: 'col' }, { children: _jsxs("label", Object.assign({ className: 'radio_label pointer' }, { children: [_jsx(PlainInput, { checked: value === setValue.toString(), className: '', input: input, meta: meta, type: 'radio', value: setValue }), _jsx("i", {}), _jsx("span", { children: name.proffitSearch })] })) }), setValue))) })), _jsx(InputError, { meta: meta })] })));
};
SlideSearchRegistrationRequestDivisionRadio.propTypes = {
    input: propShape().isRequired,
    meta: propShape().isRequired,
};
export default SlideSearchRegistrationRequestDivisionRadio;
